import { listStyleMap, whiteSpaceMap, textAlignMap, fontStyleMap } from '../../../mappers.mappings.js';
import { selectToken } from '../../../tokenSelector.js';

var typographyStyleMapper = {
  fontStyle: function fontStyle(value, _) {
    return {
      classNames: [fontStyleMap[value]]
    };
  },
  placeholderFontStyle: function placeholderFontStyle(value, _) {
    return {
      classNames: ["placeholder--".concat(fontStyleMap[value])]
    };
  },
  textAlign: function textAlign(value, _) {
    return {
      classNames: [textAlignMap[value]]
    };
  },
  textVariant: function textVariant(variant, _ref) {
    var theme = _ref.theme;
    if (!theme) {
      return {
        style: {}
      };
    }
    var textVariant = selectToken(theme.typography, variant);
    return {
      style: {
        fontSize: textVariant === null || textVariant === void 0 ? void 0 : textVariant.fontSize,
        fontWeight: textVariant === null || textVariant === void 0 ? void 0 : textVariant.fontWeight,
        lineHeight: textVariant === null || textVariant === void 0 ? void 0 : textVariant.lineHeight
      }
    };
  },
  whiteSpace: function whiteSpace(value, _) {
    return {
      classNames: [whiteSpaceMap[value]]
    };
  },
  listStyle: function listStyle(value, _) {
    return {
      classNames: [listStyleMap[value]]
    };
  },
  fontFamily: function fontFamily(value, _) {
    return {
      style: {
        fontFamily: value
      }
    };
  }
};

export { typographyStyleMapper };
//# sourceMappingURL=typography.js.map
